<svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.99988 1.41L3.41988 6L7.99988 10.59L6.58988 12L0.589879 6L6.58988 -1.23266e-07L7.99988 1.41Z" fill="#999999"/>
</svg>
